<template>
  <div
    :class="sideMenu ? 'px-6 md:px-16 xl:px-32 pt-36 ml-auto mt-20 overflow-x-hidden xl:overflow-visible relative  area-min' : 'px-6 md:px-16 overflow-x-hidden xl:overflow-visible relative  area-min'"
    class="flex flex-col main-area animate__animated animate__fadeIn"
  >
    <div class="flex flex-col sm:flex-row items-start sm:items-center jcb mb-8 w-full border-b border-gray-100 py-2">
      <div class="flex flex-col order-2 sm:order-1">
        <h1 class="nunito-bold text-gray-800">{{$t("Your orders history")}}</h1>
        <span class="fs-12 text-gray-500">{{$t("You can check your orders history here")}}</span>
      </div>
      <ol class="flex items-center space-x-2 order-1 sm:order-2 mb-4 sm:mb-0 -mt-10 sm:mt-0">
        <li>
          <div class="flex aic">
            <router-link
              to="/"
              class="fs-12 text-gray-800 hover:text-primary-color"
            >
              {{$t("Home")}}
            </router-link>
          </div>
        </li>
        <li>
          <div class="flex items-center">
            <svg
              class="flex-shrink-0 h-5 w-5 text-gray-500"
              xmlns="http://www.w3.org/2000/svg"
              fill="currentColor"
              viewBox="0 0 20 20"
              aria-hidden="true"
            >
              <path d="M5.555 17.776l8-16 .894.448-8 16-.894-.448z" />
            </svg>
            <h2
              class="ml-2 fs-12 text-gray-600"
              aria-current="page"
            >
              {{$t("Your orders history")}}
            </h2>
          </div>
        </li>
      </ol>
    </div>
    <div
      v-if="orderList.length == 0"
      class="order-history-in"
    >
      <div class="flex jcs aic cs-info-alert">
        <i class="fa fa-info-circle fs-20 mx-6"></i>
        <span class="ml-4 text-sm">{{$t("No history found")}}</span>
      </div>
    </div>
    <div
      class="flex flex-col space-y-1"
      v-for="(order, id) in orderList"
      :key="id"
    >

      <collapse :selected="false">
        <div
          slot="collapse-header"
          class="bg-gray-50"
        >

          <div class="flex aic w-full">
            <div class="flex flex-col sm:flex-row px-5 py-3 sm:py-5 justify-start lg:justify-between items-start sm:items-center w-full">
              <div class="flex md:flex-col sm:space-x-3 md:space-x-0 md:space-y-1 items-start sm:items-center md:items-start w-full lg:w-1/5">
                <span class="fs-12 hidden md:block">{{$t("Order PLaced")}}</span>
                <span class="text-xs nunito-bold">{{ formatDate(order.order.delivery_moment) }}</span>
              </div>
              <div class="hidden lg:flex flex-col space-x-3 lg:space-x-0 lg:space-y-1 items-center lg:items-start w-full lg:w-1/5">
                <span class="text-xs">{{$t("Total Amount")}}</span>
                <span class="text-xs nunito-bold">{{ currency }} {{ order.order.total_with_discount }}</span>
              </div>
              <div class="hidden lg:flex flex-col space-x-3 lg:space-x-0 lg:space-y-1 items-center lg:items-start w-full lg:w-1/5 lg:mr-auto">
                <span
                  class="text-xs"
                  v-if="order.order.user_details"
                >{{$t("Dispatched to")}}
                </span>
                <span class="text-xs nunito-bold">{{
                  JSON.parse(order.order.user_details).name
                }}</span>
              </div>
              <div class="flex md:flex-col space-x-3 md:space-x-0 md:space-y-1 items-center md:items-start w-full lg:w-4/12 justify-start md:justify-end md:pr-10">
                <span class="text-xs">{{$t("Order")}}</span>
                <span class="text-xs md:font-bold">#{{ order.order.invoice_number }}</span>
                <!-- <i class="fa fa-chevron-down text-primary"></i> -->
              </div>
            </div>

          </div>
          <div class="collapse-header-after bg-primary-color"></div>
        </div>

        <div
          slot="collapse-body"
          class="bg-white"
        >
          <div class="flex flex-col divide-y-2 divide-gray-100 divide-dashed animate__animated animate__fadeIn bill-items">
            <div class="flex flex-col lg:hidden p-5 jcb aic w-full lg:space-y-2 border-t border-dashed">
              <div class="flex space-x-3 lg:space-x-0 lg:space-y-1 items-center jcb w-full lg:w-1/5">
                <span class="text-xs">{{$t("Total Amount")}}</span>
                <b class="text-xs">{{ currency }} {{ order.order.total_with_discount }}</b>
              </div>
              <div class="flex lg:flex-col space-x-3 lg:space-x-0 lg:space-y-1 items-center jcb w-full lg:w-1/5 lg:mr-auto">
                <span
                  class="text-xs"
                  v-if="order.order.user_details"
                >{{$t("Dispatched to")}}
                </span>
                <span class="text-xs nunito-bold">{{
                  JSON.parse(order.order.user_details).name
                }}</span>
              </div>
            </div>

            <div
              class="flex flex-col md:flex-row items-stretch bill-items-in"
              v-for="(product, i) in order.products"
              :key="i"
            >
              <img
                :src="
                  product.product_image
                    ? storageUrl + product.product_image
                    : '/dish.webp'
                "
                alt=""
                class="w-full md:w-44 h-44 object-cover"
              />
              <div class="flex flex-col w-full">
                <div class="flex flex-col flex-grow px-6 py-4">
                  <div class="flex aic jcb pb-3 border-b border-gray-100">
                    <h2 class="capitalize text-primary-color text-xs">
                      {{ product.product_name }}
                    </h2>
                    <span class="text-xs">{{ currency }} {{ product.price }}</span>
                  </div>
                  <div
                    class="flex w-11/12 mt-1 text-gray-600"
                    v-if="product.depot"
                  >
                    <img
                      :src="
                            product.depot.product_image
                              ? storageUrl + product.depot.product_image
                              : '/dish.webp'
                          "
                      alt="checkout-image"
                      class="h-full w-50p object-cover rounded-xl"
                    >
                    <div class="flex items-center space-x-4">
                      <span class="fs-11 capitalize b tracking-wide whitespace-nowrap">
                        {{product.depot.product_name}}

                      </span>
                      <span class="fs-11 capitalize whitespace-nowrap">
                        <span class="font-normal  fs-12">{{ currency }}</span>

                        {{product.depot.price}}

                      </span>
                    </div>
                  </div>
                  <div
                    class="flex flex-col w-full pt-2 pb-3 space-y-1"
                    v-if="product.items.length"
                  >
                    <div
                      class="flex aic jcb"
                      v-for="(item, i) in product.items"
                      :key="i"
                    >
                      <span class="text-gray-600 text-xs"><b class="mr-2">{{ i + 1 }}.</b>{{ item.product_name }}</span>
                      <span class="text-xs">{{ currency }} {{ item.price }}</span>
                    </div>
                  </div>
                  <div
                    class="flex flex-col w-full pt-2 pb-3 space-y-1"
                    v-if="product.extras.length"
                  >
                    <div
                      class="flex aic jcb"
                      v-for="(item, i) in product.extras"
                      :key="i"
                    >
                      <span class="text-gray-600 text-xs"><b class="mr-2">{{ i + 1 }}.</b> {{ item.item }}</span>
                      <span class="text-xs">{{ currency }} {{ item.price }}</span>
                    </div>
                  </div>
                  <div class="flex aic jcb pt-3">
                    <span class="text-gray-600 text-sm nunito-bold">{{$t("Total")}}</span>
                    <span class="text-sm nunito-bold">{{ currency }}

                      {{ product.totalPrice }}</span>
                  </div>
                </div>
                <div class="flex flex-1 aic jce mx-6 py-3 border-t border-gray-100">
                  <button
                    @click="requestBill(order.order.id)"
                    type="button"
                    class="flex aic space-x-2 py-2 rounded-md text-xs mt-3 sm:mt-0 a-dark-alt"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      class="w-6 h-6"
                      fill="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path d="M22 24h-20v-24h14l6 6v18zm-7-23h-12v22h18v-16h-6v-6zm3 15v1h-12v-1h12zm0-3v1h-12v-1h12zm0-3v1h-12v-1h12zm-2-4h4.586l-4.586-4.586v4.586z" />
                    </svg>
                    <span>{{$t('Bill')}}</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </collapse>
    </div>
    <!-- pagination -->
    <div
      class="py-3 flex items-center justify-between border-t border-gray-200"
      v-if="orderListPage.total > 1"
    >
      <div class="flex-1 flex justify-between sm:hidden">
        <a
          href="#"
          class="flex items-center py-2 text-sm text-gray-700 space-x-3"
        >
          <i class="fa fa-chevron-left text-secondary"></i>
          <span class="nunito-semibold">Previous</span>
        </a>
        <a
          href="#"
          class="flex items-center py-2 text-sm text-gray-700 space-x-3"
        >
          <span class="nunito-semibold">Next</span>
          <i class="fa fa-chevron-right text-secondary"></i>
        </a>
      </div>
      <div class="hidden sm:flex-1 sm:flex sm:items-center sm:justify-between">
        <div>
          <p class="text-xs text-gray-700">
            {{$t('Showing')}}
            <span class="font-medium">{{ currentPage }}</span>
            {{$t('to')}}
            <span class="font-medium">{{ orderListPage.total_pages }}</span>
            {{$t('of')}}
            <span class="font-medium">{{ orderListPage.total }}</span>
            {{$t('results')}}
          </p>
        </div>
        <div>
          <nav
            class="relative z-0 inline-flex space-x-1"
            aria-label="Pagination"
            v-for="(page, index) in orderListPage.total_pages"
            :key="index"
          >
            <!-- Current: "z-10 bg-indigo-50 border-indigo-500 text-indigo-600", Default: "bg-white border-gray-300 text-gray-500 hover:bg-gray-50" -->
            <button
              @click="changePage(page)"
              aria-current="page"
              class="bg-white border-gray-300 text-gray-400 hover:bg-gray-50 relative inline-flex items-center px-2 py-1 border border-gray-100 text-xs font-medium"
              :class="page == currentPage ? ' text-primary' : ''"
            >
              {{ page }}
            </button>
          </nav>
        </div>
      </div>
    </div>
    <!-- end pagination -->
  </div>
</template>

<script>
import Collapse from "vue-collapse";
export default {
  components: {
    Collapse,
  },
  computed: {
    sideMenu() {
      if (process.env.VUE_APP_SIDEMENU == "side_menu") {
        return true;
      } else {
        return false;
      }
    },
    orderList() {
      return this.$store.state.orderiomApiPackage.order.orderList["order-list"];
    },
    orderListPage() {
      return this.$store.state.orderiomApiPackage.order.orderList.paginate;
    },
    currentPage() {
      return this.$store.state.orderiomApiPackage.order.orderList.paginate
        .current_page;
    },
    storageUrl() {
      return process.env.VUE_APP_STORAGE_URL;
    },
    currency() {
      return this.$store.state.orderiomApiPackage.restaurant.restaurantInfo
        .currency;
    },
  },
  methods: {
    formatDate(date) {
      date = new Date(date);
      var monthNames = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ];

      var day = date.getUTCDate();
      var monthIndex = date.getUTCMonth();
      var year = date.getFullYear();

      return day + " " + monthNames[monthIndex] + " " + year;
    },
    changePage(pageNum) {
      this.$store.dispatch("order/getOrderHistory", { page: pageNum });
    },
    requestBill(orderId) {
      this.$store.dispatch("order/requestBill", orderId).then((res) => {
        this.$swal({
          title: this.$t(res.msg),
          showCloseButton: true,
          showConfirmButton: false,
          showClass: {
            popup:
              "swal2-show " + res.type == "error" ? "md-warning" : "md-success",
          },
          customClass: "bill",
        });
      });
    },
  },
  mounted() {
    this.$store.dispatch("order/getOrderHistory");
  },
};
</script>
